module.exports = __webpack_public_path__ + "static/media/GT05_GT_Room-Attributes.9713ce03.csv";